import type { SortDir } from '../lib/tableSort.js';

/** the two-way sort mark beside a sortable header: both halves quiet, the active direction full ink.
 *  Unsorted columns show it faintly so people can see the column sorts. */
export function SortMark({ dir }: { dir: SortDir | null }) {
  return (
    <svg className={`sortmk${dir ? ' is-on' : ''}`} width="8" height="11" viewBox="0 0 8 11" aria-hidden="true">
      <path d="M4 1 7.2 4.6H.8z" className={dir === 'asc' ? 'on' : undefined} />
      <path d="M4 10 .8 6.4h6.4z" className={dir === 'desc' ? 'on' : undefined} />
    </svg>
  );
}
